<script setup lang="ts">
import { RouterView } from 'vue-router';
</script>

<template>
  <div class="content">
    <RouterView />
  </div>
</template>

<style scoped>
.content {
  height: 100%;
  overflow: auto;
}
</style>
